import { Utils } from 'src/app/configurator/product/room-builder/room-configuration/models/utils';
import { UtilityType } from '../../interfaces/GenericInterfaces';
import { UtilityDTO } from '../DTOs/UtilityDTO';
import { LocalizedText } from './LocalizedText';

export class Utility {
  public static utilityList = [
    {
      id: Utils.guid(),
      imageURL: '',
      name: [new LocalizedText('sl', 'Dodaj priključek za vodo'), new LocalizedText('en', 'Add water connector')],
      utilities: [new Utility(1001, UtilityType.Water, 'assets/icons/water.png')],
    },
    {
      id: Utils.guid(),
      imageURL: '',
      name: [
        new LocalizedText('sl', 'Dodaj priključek za elektriko'),
        new LocalizedText('en', 'Add electric connector'),
      ],
      utilities: [new Utility(1002, UtilityType.Electric, 'assets/icons/electric.png')],
    },
  ];

  public static utilities = [
    new Utility(1002, UtilityType.Electric, 'assets/icons/electric.png'),
    new Utility(1001, UtilityType.Water, 'assets/icons/water.png'),
  ];

  private _id: number | undefined;
  private _type: UtilityType;
  private _thumbnailUrl: string;

  constructor(id: number | undefined, type: UtilityType, thumbnailUrl: string) {
    this._id = id;
    this._type = type;
    this._thumbnailUrl = thumbnailUrl;
  }

  public toDTO() {
    return new UtilityDTO(this.type, this.thumbnailUrl, this._id);
  }

  public get id(): number | undefined {
    return this._id;
  }

  public set id(value: number) {
    this._id = value;
  }

  public get type(): UtilityType {
    return this._type;
  }

  public set type(value: UtilityType) {
    this._type = value;
  }

  public get thumbnailUrl(): string {
    return this._thumbnailUrl;
  }

  public set thumbnailUrl(value: string) {
    this._thumbnailUrl = value;
  }
}
